import { Link } from 'react-router-dom';
import Logo from './Logo';
import './Footer.css';

const columns = [
  {
    title: 'Platform',
    links: [
      { to: '/features', label: 'Features' },
      { to: '/technology', label: 'Technology' },
      { to: '/dashboard', label: 'Live dashboard' },
    ],
  },
  {
    title: 'Company',
    links: [
      { to: '/impact', label: 'Our impact' },
      { to: '/contact', label: 'Contact' },
      { to: '/contact', label: 'Partnerships' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { to: '/features', label: 'Documentation' },
      { to: '/technology', label: 'Hardware spec' },
      { to: '/impact', label: 'Case studies' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__top">
          <div className="footer__brand">
            <Logo variant="full" color="light" white style={{ height: 64 }} />
            <p className="footer__tagline">
              A resilient emergency communication bridge for the people who need it most.
              built for the geography of Nepal.
            </p>
            <div className="footer__badges">
              <span className="badge">LoRa-enabled</span>
              <span className="badge">Solar-ready</span>
              <span className="badge">Nepal-built</span>
            </div>
          </div>

          <div className="footer__columns">
            {columns.map((col) => (
              <div key={col.title} className="footer__col">
                <h4 className="footer__col-title">{col.title}</h4>
                <ul className="footer__list">
                  {col.links.map((l, i) => (
                    <li key={i}>
                      <Link to={l.to} className="footer__link">
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="footer__bottom">
          <p>© {new Date().getFullYear()} SETU. Connecting lives when networks fail.</p>
          <p className="footer__credit">
            Built in Nepal. Designed for the next emergency.
          </p>
        </div>
      </div>
    </footer>
  );
}
